module.exports = __webpack_public_path__ + "img/preview-10.9583a669.png";